// extracted by css-extract-rspack-plugin
export default {"infoText":"_732e4e75","bold":"_3ffe8663","productionTimeValue":"_77397c5b"};